export { customPartners, customPartnerIds } from './customPartners'
export * from './closingReasons'

export const CONTACT_TYPE_LABELS = {
  REDIRECT: 'Anruf',
  CALLBACK: 'Rückruf',
  EMAIL: 'Individuell',
  MAIL: 'Individuell',
  NOT_SET: 'Nicht gesetzt',
}
